export function formatDate(dateString, locale = 'en-GB', options = { day: '2-digit', month: '2-digit', year: '2-digit' }) {
  if (!dateString) return '';

  // Handle dates in DD-MM-YYYY format
  if (dateString.includes('-')) {
    const [day, month, year] = dateString.split('-');
    const parsedDate = new Date(year, month - 1, day); // month is 0-based in Date constructor

    if (!isNaN(parsedDate)) {
      return parsedDate.toLocaleDateString(locale, options);
    }
  }

  // Fallback to standard date parsing
  const parsedDate = new Date(Date.parse(dateString));
  if (!isNaN(parsedDate)) {
    return parsedDate.toLocaleDateString(locale, options);
  }

  // If all parsing fails, return original string with / instead of -
  return dateString.replace(/-/g, '/');
}
